import { render } from "./PaymentStatisticsChart.vue?vue&type=template&id=fc4a9b5e"
import script from "./PaymentStatisticsChart.vue?vue&type=script&lang=js"
export * from "./PaymentStatisticsChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__